<template>
<div>
  <CenterizedTile @click="dialog=true">
    <IconifiedTile>
      <template #icon>
        <Curtain size="60" :openPercent="openPercent" :openDirection="openDirection"></Curtain>
      </template>
      <template #value>{{ openPercent!=undefined ? openPercent : '---' }}</template>
      <template #unit>%</template>
      <template #title>{{ config.name || $t(`type.${info.type}`) }}</template>
    </IconifiedTile>
  </CenterizedTile>
  <CurtainControlDialog v-model="dialog" :openState="openState" @change="change" :availableOpenDirections="availableOpenDirections" @setting="showSettingsDialog"></CurtainControlDialog>
</div>
</template>

<script>
import EndpointTile from '@/components/tile/EndpointTile'
import CenterizedTile from '@/components/tile/CenterizedTile'
import IconifiedTile from '@/components/tile/IconifiedTile'
import CurtainControlDialog from '@/components/dialog/CurtainControlDialog'
import Curtain from '@/components/icon/Curtain'

export default {
  name: 'CurtainTile',
  mixins: [EndpointTile],
  components: {
    CurtainControlDialog,
    CenterizedTile,
    IconifiedTile,
    Curtain
  },
  computed: {
    open: {
      get() {
        return this.report.open;
      },
      set(val) {
        if (this.report.open != val) {
          this.$set(this.report, 'open', val);
          (this.report.openState || []).forEach(s => {
            this.$set(s, 'openPercent', val ? 100 : 0);
          });
          this.$emit('command', {
            [this.endpointId]: {
              openPercent: val ? 100 : 0
            }
          });
        }
      }
    },
    openState() {
      return this.report.openState || [];
    },
    openPercent() {
      return ((this.openState || [])[0] || {}).openPercent;
    },
    openDirection() {
      return ((this.openState || [])[0] || {}).openDirection;
    },
    availableOpenDirections() {
      return ((this.info || {}).attributes || {}).availableOpenDirections || [];
    },
    percentIcon() {
      switch (Math.round(this.openPercent / 25)) {
        case 0:
          return 'mdi-network-strength-4';
        case 1:
          return 'mdi-network-strength-3';
        case 2:
          return 'mdi-network-strength-2';
        case 3:
          return 'mdi-network-strength-1';
        default:
          return 'mdi-network-strength-outline';
      }
    },
    percentColor() {
      return this.openPercent != undefined ? 'primary' : 'grey';
    }
  },
  methods: {
    change(val) {
      if (this.openState) {
        if (val.openDirection) {
          let index = this.openState.findIndex(s => s.openDirection == val.openDirection);
          this.$set(this.report.openState, index, val);
        } else {
          this.availableOpenDirections.forEach((s, i) => {
            this.$set(this.report.openState, i, {
              openPercent: val.openPercent,
              openDirection: s
            });
          })
        }
      }
      this.$emit('command', {
        [this.endpointId]: val
      });
    }
  }
}
</script>
